import { FC } from 'react';
import { Routes, Route } from 'react-router-dom';
// Pages
import HomePage from 'pages/HomePage';
import QuizRootPage from 'pages/QuizRootPage';
import StartPage from 'pages/StartPage';
import WaiverPage from 'pages/WaiverPage';
import CountdownPage from 'pages/CountdownPage';
import QuestionPage from 'pages/QuestionPage';
// import PersonalityQuestionPage from 'pages/PersonalityQuestionPage';
import RegisterPage from 'pages/RegisterPage';
import MediaPage from 'pages/MediaPage';
import PostQuizPage from 'pages/PostQuizPage';
import LeaderboardPage from 'pages/LeaderboardPage';
import QuizGroupPage from 'pages/QuizGroupPage';
import QuizGroupLeaderboardPage from 'pages/QuizGroupLeaderboardPage';
import LiveLeaderboardPage from 'pages/LiveLeaderboardPage';
import NotFoundPage from 'pages/404.NotFound';
import AlreadyPassedPage from 'pages/AlreadyPassedPage';
import ResultsPage from 'pages/ResultsPage';
import LiveResultsPage from 'pages/LiveResultsPage';
import TimerPage from 'pages/TimerPage';
import PageHandler from 'pages/PageHandler';
import AdditionalQuestions from 'pages/AdditionalQuestions';
import TeamBoard from 'pages/TeamBoard';
import LiveTeamboardPage from 'pages/LiveTeamboardPage';
import StreakHandlerPage from 'pages/StreakHandlerPage';
import BeatTheExpertResult from 'pages/BeatTheExpertResult';
import WaitingPage from 'pages/WaitingPage';
import ScoringResultPage from 'pages/ScoringResultPage';
import QuizGroupQuizzesPage from 'pages/QuizGroupQuizzesPage';

const App:FC = () => {
  return (
    <Routes>
      <Route index element={<HomePage />} />
      <Route path="quiz/:slug/live-leaderboard" element={<LiveLeaderboardPage />} />
      <Route path="quiz-group/:groupSlug/live-leaderboard" element={<LiveLeaderboardPage />} />
      <Route path="quiz-group/:groupSlug" element={<QuizGroupQuizzesPage />} />
      <Route path="quiz/:slug/live-results" element={<LiveResultsPage />} />
      <Route path="quiz/:slug/live-teamboard" element={<LiveTeamboardPage />} />
      <Route path="quiz" element={<QuizRootPage />} >
        <Route path=":slug" element={<StartPage />} />
        <Route path=":slug/waiver" element={<WaiverPage />} />
        <Route path=":slug/countdown" element={<CountdownPage />} />
        <Route path=":slug/media" element={<MediaPage />} />
        <Route path=":slug/question" element={<QuestionPage />} />
        <Route path=":slug/additionalQuestions" element={<AdditionalQuestions />} />
        <Route path=":slug/timer" element={<TimerPage />} />
        <Route path=":slug/waiting" element={<WaitingPage />} />
        <Route path=":slug/register" element={<RegisterPage />} />
        <Route path=":slug/already-passed" element={<AlreadyPassedPage />} />
        <Route path=":slug/post-quiz" element={<PostQuizPage />} />
        <Route path=":slug/leaderboard" element={<LeaderboardPage />} />
        <Route path=":slug/results" element={<ResultsPage />} />
        <Route path=":slug/teamboard" element={<TeamBoard />} />
        <Route path=":slug/quiz-group/:groupSlug" element={<QuizGroupPage />} />
        <Route path=":slug/quiz-group-leaderboard/:groupSlug" element={<QuizGroupLeaderboardPage />} />

        <Route path=":slug/pages-handler" element={<PageHandler />} />
        <Route path=":slug/streak-handler" element={<StreakHandlerPage />} />
        <Route path=":slug/beat-the-expert-result" element={<BeatTheExpertResult />} />
        <Route path=":slug/scoring-result" element={<ScoringResultPage />} />
      </Route>

      <Route path="404-not-found" element={<NotFoundPage />} />
    </Routes>
  );
}

export default App;
